<app-header></app-header>
<app-navbar></app-navbar>
<div class="d-flex">
    <aside role="complementary" [attr.aria-label]="'asideDescription' | translate">
        <app-sidebar [items]="links"></app-sidebar>
    </aside>
    <main class="ps-5 w-100">
        <!-- Tabla de tipos de IVA -->

        <div class="row mb-3">
            <div class="text-end d-flex align-items-center col-12 mt-2 justify-content-between">
                <h2 class="mb-3 textformat">{{ "sidebar.ivaPattern" | translate }}</h2>
                <button type="button" class="btn custombutton" (click)="newVat()">
                    {{ "patternVat.nuevoPatron" | translate }}
                </button>
            </div>
        </div>
        @if (this.vatPatternResponse.listVatPatternDto &&
        this.vatPatternResponse.listVatPatternDto.length > 0) {
        <div>
            <fieldset role="radiogroup">
                <table id="table1" class="table" role="grid" [attr.aria-label]="'sidebar.ivaPattern' | translate">
                    <thead>
                        <tr role="row">
                            <th scope="col"><span class="visually-hidden">{{ 'seleccionarFila' | translate }}</span>
                            </th>
                            <th scope="col">{{ "patternVat.codi" | translate }}</th>
                            <th scope="col">{{ "typesVat.description" | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of vatPatternResponse.listVatPatternDto; trackBy: trackById"
                            [ngClass]="{ resaltado: selectedRowId === row.idVatPattern }" role="row">
                            <td role="gridcell">
                                <input [ariaLabel]="'flexRadioDefault' + row.idVatPattern" type="radio"
                                    [id]="'radio-' + row.idVatPattern" name="checkbox1"
                                    [checked]="selectedRowId === row.idVatPattern" (click)="toggleRow(row)" />
                                <label [for]="'radio-' + row.idVatPattern" class="visually-hidden">
                                    {{ "seleccionarFilaCon" | translate }} {{ "patternVat.codi" | translate }} {{
                                    row.codePatternVat }} y {{ "typesVat.description" | translate }} {{
                                    row.vatPatternTraductionDto?.[0]?.description || 'sin descripción' }}
                                </label>
                            </td>
                            <td role="gridcell">{{ row.codePatternVat }}</td>
                            <td role="gridcell">
                                <span *ngIf="row.vatPatternTraductionDto">
                                    {{ row.vatPatternTraductionDto[0].description }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>

            <div class="mt-2" *ngIf="this.vatPatternResponse.pageDto">
                <app-paginator [isStart]="this.vatPatternResponse.pageDto.start"
                    [isEnd]="this.vatPatternResponse.pageDto.end"
                    [currentPage]="this.vatPatternResponse.pageDto.currentPage"
                    [totalPages]="this.vatPatternResponse.pageDto.pages"
                    [numberRecord]="this.vatPatternResponse.pageDto.records"
                    [sizePage]="this.vatPatternResponse.pageDto.pageSize">
                </app-paginator>
            </div>
        </div>
        }
        <!-- Formulario de tasas administrativas -->
        @if (vatPatternFormVisible) {
        <div>
            <div>
                <div class="separator mt-5"></div>
                <h2 class="mb-3 mt-4 textformat">
                    {{ "sidebar.ivaPattern" | translate }}
                </h2>
            </div>
            <form [formGroup]="vatPatternForm">
                <div class="row">
                    <div class="modelinput col-6">
                        <label for="codePatternVat">{{ "administrativeTaxes.code" | translate
                            }}<span> *</span></label>
                        <input type="text" id="codePatternVat" name="codePatternVat" class="form-control"
                            formControlName="codePatternVat" />
                    </div>

                    <div class="col-6 modelinput-flex">
                        <label for="descriptionCat">{{ "administrativeTaxes.catDescription" | translate
                            }}<span> *</span></label>
                        <input type="text" class="form-control" id="descriptionCat" name="descriptionCat"
                            placeholder="Ingrese la descripción en catalán" formControlName="descriptionCat" />
                    </div>
                    <div class="col-6 modelinput-flex">
                        <label for="descriptionCast">{{ "administrativeTaxes.castDescription" | translate
                            }}<span> *</span></label>
                        <input type="text" id="descriptionCast" name="descriptionCast" class="form-control"
                            placeholder="Ingrese la descripción en castellano" formControlName="descriptionCast" />
                    </div>
                    <div class="col-6 modelinput-flex">
                        <label for="descriptionIng">{{ "administrativeTaxes.engDescription" | translate
                            }}<span> *</span></label>
                        <input type="text" name="descriptionIng" id="descriptionIng" class="form-control"
                            placeholder="Ingrese la descripción en inglés" formControlName="descriptionIng" />
                    </div>
                </div>

                <div class="row d-flex">
                    <div class="col-12 mt-4">
                        <button type="button" class="btn cancelbutton me-2" (click)="onCancel()">
                            Cancelar
                        </button>
                        <button type="button" class="btn custombutton" (click)="saveOrUpdateVatPattern()">
                            {{
                            selectedRowId
                            ? ("buttons.modify" | translate)
                            : ("buttons.save" | translate)
                            }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <app-alert-component [isOk]="messageVisibility.isSuccessFirst" [isDanger]="messageVisibility.isErrorFirts"
            [message]="errorMessage" (close)="
        messageVisibility.isSuccessFirst = messageVisibility.isErrorFirts =
          false
      "></app-alert-component>
        <div *ngIf="selectedRowId" class="row mb-3">
            <div class="text-end d-flex align-items-center col-12 mt-2 justify-content-between">
                <h2 class="mb-3 textformat">
                    {{ "sidebar.configurations" | translate }}
                </h2>
                <button type="button" class="btn custombutton" (click)="newConfigVat()">
                    {{ "buttons.newRegister" | translate }}
                </button>
            </div>
        </div>
        @if(vatConfigResponse && vatConfigResponse.vatConfigPatternDto.length>0){
        <fieldset>
            <table id="table2" class="table mt-3 mb-3" role="grid"
                [attr.aria-label]="'sidebar.configurations' | translate">
                <thead>
                    <tr role="row">
                        <th scope="col"><span class="visually-hidden">{{ 'seleccionarFila' | translate }}</span></th>
                        <th scope="col">{{ "UE" }}</th>
                        <th scope="col">{{ "patternVat.pais" | translate }}</th>
                        <th scope="col">{{ "patternVat.comunidad" | translate }}</th>
                        <th scope="col">{{ "patternVat.provincia" | translate }}</th>
                        <th scope="col">{{ "patternVat.tipusVat" | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of vatConfigResponse.vatConfigPatternDto; let i = index"
                        [ngClass]="{ resaltado: selectedConfigRowId === row.idVatConfigPattern }" role="row">
                        <td role="gridcell">
                            <input type="radio" [id]="'radio-' + row.idVatConfigPattern" name="checkbox"
                                [checked]="selectedConfigRowId === row.idVatConfigPattern"
                                (click)="toggleRowConfig(row)" />
                            <label [for]="'radio-' + row.idVatConfigPattern" class="visually-hidden">
                                {{ "seleccionarFilaCon" | translate }}:
                                {{ "UE" }} {{ row.euIndicator === 'S' ? ('academicTaxes.S' | translate) :
                                ('academicTaxes.N'
                                | translate) }},
                                {{ "patternVat.pais" | translate }} {{ getCountryName(row.countryCode) || 'N/A' }},
                                {{ "patternVat.comunidad" | translate }} {{ getCommunityName(row.communityCode) || 'N/A'
                                }},
                                {{ "patternVat.provincia" | translate }} {{ getProvinceName(row.provinceCode) || 'N/A'
                                }},
                                {{ "patternVat.tipusVat" | translate }} {{ getVatRateName(row) || 'N/A' }}
                            </label>
                        </td>
                        <td role="gridcell">
                            <span *ngIf="row.euIndicator == 'S'">{{ "academicTaxes.S" | translate }}</span>
                            <span *ngIf="row.euIndicator == 'N'">{{ "academicTaxes.N" | translate }}</span>
                        </td>
                        <td role="gridcell">{{ getCountryName(row.countryCode) || '' }}</td>
                        <td role="gridcell">{{ getCommunityName(row.communityCode) || '' }}</td>
                        <td role="gridcell">{{ getProvinceName(row.provinceCode) || '' }}</td>
                        <td role="gridcell">{{ getVatRateName(row) || '' }}</td>
                    </tr>
                </tbody>
            </table>
        </fieldset>

        <div class="mt-2" *ngIf="this.vatConfigResponse.pageDto">
            <app-paginator [isStart]="this.vatConfigResponse.pageDto.start" [isEnd]="this.vatConfigResponse.pageDto.end"
                [currentPage]="this.vatConfigResponse.pageDto.currentPage"
                [totalPages]="this.vatConfigResponse.pageDto.pages"
                [numberRecord]="this.vatConfigResponse.pageDto.records"
                [sizePage]="this.vatConfigResponse.pageDto.pageSize">
            </app-paginator>
        </div>
        } @if (vatConfigPatternFormVisible) {
        <form [formGroup]="vatConfigForm">
            <div class="row">
                <div class="mb-3 col-4">
                    <label for="ue">{{ "patternVat.union" | translate }}<span> *</span></label>
                    <select id="ue" class="form-select" formControlName="ue">
                        <option value="S">{{ "academicTaxes.S" | translate }}</option>
                        <option value="N">{{ "academicTaxes.N" | translate }}</option>
                    </select>
                </div>
                <div class="mb-3 col-4">
                    <label for="country">{{ "patternVat.pais" | translate }}<span> *</span></label>
                    <select class="form-select" id="country" name="country" formControlName="country">
                        <option *ngFor="let country of getCountriesUE(countries)" [value]="country.countryCode">
                            <span *ngIf="translateService.currentLang == 'ca'">{{
                                country.descriptionCa
                                }}</span>
                            <span *ngIf="translateService.currentLang == 'es'">{{
                                country.descriptionEs
                                }}</span>
                            <span *ngIf="translateService.currentLang == 'en'">{{
                                country.descriptionEn
                                }}</span>
                        </option>
                    </select>
                </div>
                <div class="mb-3 col-4">
                    <label for="comunnity">{{ "patternVat.comunidad" | translate }}<span> *</span></label>
                    <select class="form-select" id="comunnity" name="comunnity" formControlName="comunnity">
                        <option *ngFor="let communitie of communities" [value]="communitie.communityCode">
                            <span *ngIf="translateService.currentLang == 'ca'">{{
                                communitie.communityDescriptionCa
                                }}</span>
                            <span *ngIf="translateService.currentLang == 'es'">{{
                                communitie.communityDescriptionEs
                                }}</span>
                            <span *ngIf="translateService.currentLang == 'en'">{{
                                communitie.communityDescriptionEn
                                }}</span>
                        </option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <label for="province">{{ "patternVat.provincia" | translate }}<span> *</span></label>
                    <select class="form-select" id="province" name="province" formControlName="province">
                        <option *ngFor="let province of provincesByCommunity" [value]="province.provinceCode">
                            <span *ngIf="translateService.currentLang == 'ca'">{{
                                province.provinceDescriptionCa
                                }}</span>
                            <span *ngIf="translateService.currentLang == 'es'">{{
                                province.provinceDescriptionEs
                                }}</span>
                            <span *ngIf="translateService.currentLang == 'en'">{{
                                province.provinceDescriptionEn
                                }}</span>
                        </option>
                    </select>
                </div>
                <div class="col-4">
                    <label for="vatRate">{{ "patternVat.tipusVat" | translate }}<span> *</span></label>
                    <select class="form-select" id="vatRate" name="vatRate" formControlName="vatRate">
                        <option *ngFor="let vatRate of listVatRate" [value]="vatRate.idVatRate">
                            <span *ngIf="vatRate.vatRateTraductionDto">{{
                                vatRate.vatRateTraductionDto[0].description
                                }}</span>
                        </option>
                    </select>
                </div>
            </div>
        </form>
        <div class="row d-flex">
            <div class="col-12 mt-4">
                <button type="button" class="btn cancelbutton me-2" (click)="onCancelType()">
                    Cancelar
                </button>
                <button type="button" class="btn custombutton" (click)="saveOrUpdateVatConfig()">
                    {{
                    selectedConfigRowId
                    ? ("buttons.modify" | translate)
                    : ("buttons.save" | translate)
                    }}
                </button>
            </div>
        </div>
        } }
        <app-alert-component [isOk]="messageVisibility.isSuccessSecond" [isDanger]="messageVisibility.isErrorSecond"
            [message]="errorMessage" (close)="
        messageVisibility.isSuccessSecond = messageVisibility.isErrorSecond =
          false
      "></app-alert-component>
    </main>
</div>